import type { ReactNode } from 'react'
import { View } from 'react-native'

import { HozanimatedLoader } from '@/src/elements/HozanimatedLoader/HozanimatedLoader'
import { useInfiniteFeed } from '@/src/features/prayer-space/services/useInfiniteFeed'
import type { TSourceParam } from '@/src/general/constants/routes'
import { TEST_ID } from '@/src/general/constants/testId'
import { parseIdDash } from '@/src/general/utils/parseIdDash'

import { CommunityJoinNextFirstPublication } from './CommunityJoinNextFirstPublication'
import { CommunityJoinNextSuggestions } from './CommunityJoinNextSuggestions'

export const CommunityJoinNextScreen = ({ idSlug }: TIdSlugParam & TSourceParam): ReactNode => {
  const [communityId] = parseIdDash(idSlug)
  const { data: feed, isLoading, isRefetching, isFetching } = useInfiniteFeed()

  if (isLoading) return null

  const firstPublication =
    feed?.transformedSections?.length && feed?.transformedSections?.length > 0
      ? feed?.transformedSections[0].data?.[0].publication
      : undefined

  const isSameCommunity = firstPublication?.community.id === communityId

  if (isLoading || isFetching || isRefetching)
    return (
      <View testID={TEST_ID.COMMUNITY.JOIN_NEXT_SCREEN} className="flex-1 items-center justify-center">
        <HozanimatedLoader />
      </View>
    )

  if (firstPublication && isSameCommunity) return <CommunityJoinNextFirstPublication publication={firstPublication} />

  return <CommunityJoinNextSuggestions communityId={communityId} />
}
